<template>
  <div>
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title>Cambiar contraseña</v-toolbar-title>
      </v-toolbar>
      <v-alert type="error" dismissible v-model="alertError">
        {{ error }}
      </v-alert>
      <v-alert type="success" dismissible v-model="alertaExito">
        Contraseña cambiada con éxito
      </v-alert>
      <form @submit.prevent="changePassword">
        <v-card-text>
          <v-text-field
            required
            id="current-password"
            prepend-icon="lock"
            autocomplete="current-password"
            name="current-password"
            label="Contraseña actual"
            v-model="password"
            type="password"
            counter
            maxlength="50"
          ></v-text-field>
          <v-text-field
            required
            id="newPassword"
            prepend-icon="lock"
            autocomplete="new-password"
            name="new-password"
            label="Nueva contraseña"
            v-model="newPassword"
            type="password"
            :rules="[compareNewPassword]"
            counter
            maxlength="50"
          ></v-text-field>
          <v-text-field
            required
            id="passwordConfirm"
            prepend-icon="none"
            name="password"
            autocomplete="new-password"
            label="Repetir nueva contraseña"
            v-model="passwordConfirm"
            type="password"
            :rules="[comparePasswords]"
            counter
            maxlength="50"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-layout wrap align-center justify-center>
            <v-flex xs12 md5>
              <v-btn block color="primary" type="submit" :disabled="validateInputs" :loading="loading">
                Cambiar contraseña
              </v-btn>
            </v-flex>
            <v-flex xs12 md2><br /></v-flex>
            <v-flex xs12 md5>
              <v-btn block color="secondary" to="/restore">
                He olvidado mi contraseña
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </div>
</template>

<script>
//Formulario para cambiar de contraseña
// @group Configurar usuario
export default {
  name: "ChangePassword",
  data() {
    return {
      procesando: false,
      alertError: false,
      alertaExito: false,
      password: "",
      newPassword: "",
      passwordConfirm: ""
    };
  },
  methods: {
    // @vuese
    // Cambiar email
    // @arg La contraseña actual y la nueva
    changePassword() {
      this.alertError = false;
      this.alertaExito = false;
      this.$store
        .dispatch("changePassword", {
          currentPassword: this.password,
          newPassword: this.newPassword
        })
        .then(() => {
          this.alertaExito = true;
          this.password = "";
          this.newPassword = "";
          this.passwordConfirm = "";
        })
        .catch(error => {
          this.alertError = true;
        });
    }
  },
  computed: {
    // @vuese
    // Comprueba si las condiciones se cumplen
    validateInputs() {
      if (
        this.password === "" ||
        this.newPassword === "" ||
        this.passwordConfirm === "" ||
        this.loading ||
        this.comparePasswords !== true ||
        this.compareNewPassword !== true
      ) {
        return true;
      } else {
        return false;
      }
    },
    // @vuese
    // Comprueba que las dos contraseñas sean iguales
    comparePasswords() {
      return this.passwordConfirm === "" || this.newPassword === this.passwordConfirm
        ? true
        : "Las contraseñas no coinciden";
    },
    // @vuese
    // Comprueba que la nueva contraseña sea distinta
    compareNewPassword() {
      return this.newPassword === "" || this.newPassword !== this.password
        ? true
        : "La nueva contraseña debe ser distinta";
    },
    // @vuese
    // Indica el error
    error() {
      return this.$store.state.error;
    },
    // @vuese
    // Indica si el sistema está cargando
    loading() {
      return this.$store.state.loading;
    }
  },
  watch: {
    alertError(value) {
      if (!value) {
        this.$store.commit("setError", null);
      }
    }
  }
};
</script>
